import { useQuery } from 'react-query';
import { useRef } from 'react';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { useStore } from '../../store';
import { useInitializeApiQuery } from './useInitializeApiQuery';
import { setPeopleProperty } from '../../services/mixpanel.service';
import { generatePeoplePropertyProps } from '../../flows/login/login.service';
import bugsnagHandler from '../../services/bugsnag.service';
import { getFromLocalStorage, setToLocalStorage } from '../../services/storage.service';

const {
  BASE,
  CONTROLLERS: { ACCOUNT },
} = USER;

const CONTROLLER_URL = BASE.replace('{version}', ACCOUNT.ROUTES.SUMMARY.VERSION);

const ENDPOINT_URL = `${ACCOUNT.BASE}/${ACCOUNT.ROUTES.SUMMARY.BASE}/?fetchSubAccount=true`;

export const useAccountSummaryQuery = (
  onSuccess?: (accountSummary: any) => void,
  id?: string,
  customQueryKey?: string,
) => {
  const setAccountSummary = useStore((state) => state.setSummary);
  const personExternalId = useStore((state) => state.getPersonExternalId());
  const { currUser } = useStore.getState();
  const setUser = useStore((state) => state.setUser);
  const authUserIdInLocalStorage = getFromLocalStorage('authUserId');

  const currCustomerId = useRef('');

  const { refetch: queryInitializeApi } = useInitializeApiQuery(currCustomerId.current);

  const getExtendedParam = () => {
    // const param = authorizedUserId || authUserIdInLocalStorage;
    const param = currUser()?.authorizedUserId || authUserIdInLocalStorage;
    if (param) {
      return `&authorizedUserId=${param}`;
    }
    return '';
  };

  return useQuery(
    customQueryKey || 'accountSummary',
    () =>
      httpService.get(
        `${BASE_URL}/${CONTROLLER_URL}/${id || currUser()?.customerId}/${ENDPOINT_URL}${getExtendedParam()}`,
      ),
    {
      enabled: false,
      onSuccess: async (res: { data: any }) => {
        currCustomerId.current = res.data.customer.externalId;
        // TODO: need the external id for other roles
        if (res.data.authorizedUserData) {
          setToLocalStorage({
            key: 'authUserId',
            value: res?.data?.authorizedUserData?.externalId,
          });
          setUser({
            ...currUser(),
            authorizedUserId: res?.data?.authorizedUserData?.externalId,
            authorizedUserType: res.data.authorizedUserType,
          });
        }
        await setAccountSummary(res.data);
        await queryInitializeApi();
        try {
          await setPeopleProperty(generatePeoplePropertyProps());
          (<any>window).hj('identify', personExternalId, {
            Plan: res?.data?.customerProfileInfo?.customerProfile,
            personId: personExternalId,
            customerId: id || currUser()?.customerId,
          });
        } catch (e) {
          bugsnagHandler.notify('HotJar is not available');
        }

        if (onSuccess) onSuccess(res.data);
      },
      onError: (_error: any) => _error.response?.status,
      retry: 0,
      cacheTime: 0,
    },
  );
};
